import { Link } from 'expo-router';
import { Platform, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { Button } from '@sixam/ui/button';
import { Text } from '@sixam/ui/text';

export default function LandingScreen() {
  // SafeAreaView reads native insets, so it cannot see the zeroed top inset that
  // AndroidStatusBarInset hands to its descendants. Dropping the top edge on
  // Android keeps it from reserving the status bar a second time.
  return (
    <SafeAreaView
      className="flex-1 bg-background"
      edges={Platform.OS === 'android' ? ['bottom', 'left', 'right'] : undefined}
    >
      <View className="flex-1 justify-center gap-8 p-6">
        <View className="gap-2">
          <Text variant="h1" className="text-left">
            6am
          </Text>
          <Text variant="muted">A universal Expo + Supabase starter.</Text>
        </View>

        <View className="gap-3">
          <Link href="/(public)/sign-in" asChild>
            <Button>
              <Text>Sign in</Text>
            </Button>
          </Link>
          <Link href="/(public)/sign-up" asChild>
            <Button variant="outline">
              <Text>Create an account</Text>
            </Button>
          </Link>
        </View>
      </View>
    </SafeAreaView>
  );
}
